import {Model} from './model';
import {Company} from "./company";
import {Contract} from "./contract";
import {TestBed} from "@angular/core/testing";
import {Box} from "./box";
import {ResearcherCertificate} from "./researcher-certificate";
import {Permission} from "./permission";
import {PermissionName} from "../utils/constants";

export class User extends Model {

  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  address?: string | undefined;
  identityProviderId?: string;

  enabled?: boolean;
  m2mEnabled?: boolean;

  notifications?: any[];
  emailVerificationToken?: any;
  permissions?: Permission[];

  /* Researcher permission properties */
  boxes?: Box[];
  contracts?: Contract[];
  reports?: any[];
  certificates?: ResearcherCertificate;
  /**/

  /* Tester permission property */
  testbeds?: TestBed[];
  /**/

  /* Customer permission properties */
  company?: Company;
  organizationName?: string | undefined;

  /**/

}


export function hasPermission(user: User | undefined | null, permission: PermissionName): boolean {
  return user?.permissions?.some(value => value.name === permission);
}

export function hasAnyPermission(user: User | undefined | null, permissions: PermissionName[]): boolean {
  return user?.permissions?.some(value => permissions.includes(value.name as PermissionName));
}
